import { DASHBOARD_EXCLUDED_ASSOCIATION_CONTEXT_NAMES } from '#/constants/dashboard-message-filters';
import type { GetMessagesQueryVariables } from '#/graphql/generated';

export type BuildGetMessagesVariablesInput =
  | { kind: 'dashboard-filtered' }
  | { kind: 'dashboard-all' }
  | { kind: 'document'; documentId: string };

export function buildGetMessagesVariables(
  input: BuildGetMessagesVariablesInput,
): GetMessagesQueryVariables {
  switch (input.kind) {
    case 'dashboard-filtered':
      return {
        input: {
          excludeContextNames: [
            ...DASHBOARD_EXCLUDED_ASSOCIATION_CONTEXT_NAMES,
          ],
        },
      };
    case 'dashboard-all':
      return {};
    case 'document':
      return {
        input: {
          contextFilters: [{ name: 'documentId', value: input.documentId }],
        },
      };
  }
}
